var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecommended(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 0.875,
    width: 40,
    height: 40,
    rx: 8,
    fill: "#0869FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5526 17.4289L17.4614 14.8747C17.6575 14.323 18.0035 13.8486 18.4538 13.514C18.9041 13.1793 19.4375 13.0001 19.9838 13H27.5682C27.7814 13.001 27.991 13.0582 28.1792 13.1666C28.3673 13.2749 28.5282 13.4312 28.648 13.6219C28.7678 13.8126 28.8429 14.032 28.8667 14.2611C28.8906 14.4902 28.8626 14.7222 28.785 14.9369L27.8762 17.4289H16.5526ZM16.2729 18.2165L14.7037 22.6312H23.8422C24.504 22.5697 25.1369 22.3099 25.6698 21.8809C26.2028 21.4519 26.6147 20.8708 26.8594 20.2026L27.5854 18.2165H16.2729ZM14.424 23.4178L12.875 27.7745H16.2012C16.5858 27.7745 16.9614 27.6485 17.2787 27.4132C17.5959 27.1778 17.8398 26.8441 17.9784 26.4559L19.0639 23.4178H14.424Z",
    fill: "url(#paint0_linear_1133_56246)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1133_56246",
    x1: 20.8765,
    y1: 12.4319,
    x2: 20.8765,
    y2: 28.3361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BB3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F64FA"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommended);
export default __webpack_public_path__ + "static/media/Recommended.67cfbfbb1575f739cae82cae2ef2a850.svg";
export { ForwardRef as ReactComponent };